import ProfilePICBonusRow from '@atoms/ProfilePICBonusRow';
import ProfilePointsRow from '@atoms/ProfilePointsRow';
import { Divider, Text, View } from '@components/primitives';
import appStyles from '@root/appStyles';
import { getStore } from '@store/storeUtils';
import colors from '@theme/colors';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ProfileBonusProps {
  showBonus?: boolean;
}

interface EmployeeProfile {
  influencerRole?: string;
  // Add other profile properties if needed
}

interface StoreState {
  employeeProfile?: EmployeeProfile;
}

function ProfileBonus({ showBonus = false }: ProfileBonusProps) {
  const { employeeProfile } = getStore() as StoreState;
  const { t } = useTranslation('common');

  const isPIC = useMemo(() => employeeProfile?.influencerRole === 'PIC', [employeeProfile?.influencerRole]);

  return (
    <>
      <View style={appStyles.marginLeft(16)} marginY="16px">
        <Text testID="txtProfileBonusHeader" variant="md-bold">
          {t('profile.bonusHeader')}
        </Text>
        <ProfilePointsRow />
        {showBonus && isPIC && <ProfilePICBonusRow />}
      </View>
      <Divider height="4px" backgroundColor={colors.neutral.mist} />
    </>
  );
}

export default React.memo(ProfileBonus);
